import { useMemo } from 'react';
import { DEFAULT_LIMIT, sortFieldsToStrings } from '../constants/filters';
import { useIsPreview } from '../hooks/useIsPreview';
import { getPreviewTicketListings } from './previewMocks';
import { toSearchTicket } from './searchTickets';
import { useTicketListingsSearch } from './useTicketListingsSearch';
export function useResolvedTicketListings(variables) {
  var _previewTicketListing;
  const isPreview = useIsPreview();
  const ticketListings = useTicketListingsSearch(variables);
  const previewTicketListings = useMemo(() => {
    var _variables$pageLength;
    return isPreview ? getPreviewTicketListings({
      searchString: variables.searchString,
      createDateFilter: variables.createDateFilter,
      lastActivityFilter: variables.lastActivityFilter,
      offset: variables.offset,
      limit: (_variables$pageLength = variables.pageLength) !== null && _variables$pageLength !== void 0 ? _variables$pageLength : DEFAULT_LIMIT,
      sort: sortFieldsToStrings(variables.sort),
      statusFilter: variables.statusFilter,
      ticketView: variables.ticketView
    }) : null;
  }, [isPreview, variables.createDateFilter, variables.lastActivityFilter, variables.offset, variables.pageLength, variables.searchString, variables.sort, variables.statusFilter, variables.ticketView]);
  return Object.assign({}, ticketListings, {
    data: isPreview ? previewTicketListings === null || previewTicketListings === void 0 ? void 0 : previewTicketListings.results.map(toSearchTicket) : ticketListings.data,
    total: isPreview ? (_previewTicketListing = previewTicketListings === null || previewTicketListings === void 0 ? void 0 : previewTicketListings.total) !== null && _previewTicketListing !== void 0 ? _previewTicketListing : 0 : ticketListings.total,
    loading: isPreview ? false : ticketListings.loading,
    error: isPreview ? undefined : ticketListings.error
  });
}